<template>
	<div>
		<el-card>
			<div v-if="getFormConfig" slot="header">
				<span v-html="clearPLabel(getFormConfig.label)"></span>
			</div>
			<el-alert
				v-if="getFormConfig && getFormConfig.notice"
				:title="getFormConfig.notice.content"
				show-icon
				style="margin-bottom: 10px"
				type="warning"></el-alert>
			<avue-form v-model="planFormData" v-loading="isLoading" :option="planOption" @submit="onSubmitPlan">
				<template #menuForm="{}">
					<el-button v-if="!planOption.submitBtn && !isAdd" icon="el-icon-edit" @click="onCheckPlanResult(false)">
						修改
					</el-button>
				</template>
			</avue-form>
		</el-card>
		<InsureNotices ref="refInsureNotices" @onToCancel="onToCancel" @onToInsure="onGoInsure"></InsureNotices>
	</div>
</template>
<script>
import {basePlanOption, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {clearHtml, clearPLabel, isAllDataReady} from 'meibao-insure/src/util/commonUtils'
import InsureNotices from 'meibao-insure/src/components/InsureNotices.vue'
import {isAnZeProduct} from 'meibao-insure/src/util/productUtil'
import {emit_plan_check} from 'meibao-insure/src/util/emitDic'

export default {
	name: 'FormPlanNew',
	components: {InsureNotices},
	props: {
		// productId: {
		//   type: String | Number,
		//   required: true
		// },
		// sourceProductId: {
		//   type: String | Number,
		//   required: true
		// },
		insureType: String | Number,
		planFormAllData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		dutyInfoData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		isAdd: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isLoading: false,
			planOption: {},
			mapPlan: {},
			planFormData: {
				amount: '',
			},
			//如果是从重新提交等进入的，默认设置的数据，不弹窗
			isShowHint: true,
			//家电三者
			thirdType: '0',
			unitFormData: {},
			doneData: null,
		}
	},
	mounted() {
		this.onSendCalc = _.debounce(this.onSendCalc, 600)
		this.$Bus.$on(emit_plan_check, this.onUnitCheck)
	},
	activated() {
		this.$Bus.$on(emit_plan_check, this.onUnitCheck)
	},
	deactivated() {
		this.$Bus.$off(emit_plan_check, this.onUnitCheck)
	},
	computed: {
		getFormConfig() {
			if (this.validatenull(this.planFormAllData.config)) {
				return ''
			}
			return this.planFormAllData.config
		},
	},
	watch: {
		planFormAllData: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					//开始处理方案数据
					let {duties = []} = this.dutyInfoData
					this.planOption = getCompleteOption(newVal, basePlanOption(newVal, duties))
					//如果是批增，则不显示按钮
					this.$nextTick(() => {
						//如果为泰康产品。label 要加宽
						if (isAnZeProduct(this.insureType)) {
							this.planOption.labelWidth = 260
						}
						//处理展示是否使用textarea
						this.onShowContentType()
						if (this.isAdd) {
							this.planOption.menuBtn = false
							this.planOption.column.forEach((itemData) => {
								let {prop = '', value = ''} = itemData
								itemData.disabled = true
								//并且设置默认值
								if (value !== '') {
									this.planFormData[prop] = value
								}
							})
						} else {
							//处理数据显隐！！！！
							this.onChangeOption()
						}
					})
					console.log('planOption-----', this.planOption)
				}
			},
			immediate: true,
		},
		planFormData: {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal)) {
					//判断是否所有数据都好了
					if (!isAllDataReady(newVal)) {
						return
					}
					this.isLoading = true
					setTimeout(() => {
						this.isLoading = false
					}, 1500)
					this.onSendCalc()
				}
			},
			deep: true,
		},
		'planFormData.amount': {
			handler(newVal = '') {
				if (newVal) {
					//根据所选的数据，处理planFormData
					this.planFormData.coverage = newVal
					this.onDealOtherData(newVal)
					//处理是不是有提示
					if (this.isShowHint) {
						this.onHasHint(newVal, 'amount')
					}
				}
			},
			immediate: true,
		},
		//切换数据，会有弹窗
		'planFormData.loadDuty': {
			handler(newVal = '') {
				if (!this.validatenull(newVal)) {
					//处理是不是有提示
					this.onHasHint(newVal, 'loadDuty')
				}
			},
		},
		//全国地区方案切换数据，会有弹窗
		'planFormData.areaDim': {
			handler(newVal = '') {
				if (!this.validatenull(newVal)) {
					//处理是不是有提示
					this.onHasHint(newVal, 'areaDim')
				}
			},
		},
		//自费药label切换
		'planFormData.costDuty': {
			handler(newVal = '') {
				if (!this.validatenull(newVal)) {
					//处理切换label
					//处理数据显隐！！！！
					this.onChangeOption()
				}
			},
		},
		//处理家电第三者
		'planFormData.thirdDuty': {
			handler(newVal = '') {
				if (newVal) {
					// this.onJiandianThird()
					//处理切换label
					//处理数据显隐！！！！
					this.onChangeOption()
					//处理是不是有提示
					this.onHasHint(newVal, 'thirdDuty')
				}
			},
		},
		//个意险意外医疗控制其他参数
		'planFormData.insureAccident': {
			handler(newVal = '') {
				if (newVal) {
					//处理切换label
					//处理数据显隐！！！！
					this.onChangeOption()
				}
			},
		},
		//猝死
		'planFormData.insureSuddenDeath': {
			handler(newVal = '') {
				if (newVal) {
					//处理切换label
					//处理数据显隐！！！！
					this.onChangeOption()
					//处理是不是有提示
					this.onHasHint(newVal, 'insureSuddenDeath')
				}
			},
		},
		//猝死
		'planFormData.addMaim': {
			handler(newVal = '') {
				if (newVal) {
					//处理切换label
					//处理数据显隐！！！！
					this.onChangeOption()
				}
			},
		},
	},
	methods: {
		clearPLabel,
		//发送计算保费消息
		onSendCalc() {
			//修改数据，则需要重新计算保费
			this.$emit('onNeedCalcPrice', true)
		},
		//选择保费，处理费用
		onDealOtherData(amount) {
			let {ensureAmounts = []} = this.dutyInfoData
			let tempData = ensureAmounts.find(({ensureAmount}) => ensureAmount === amount + '')
			if (!this.validatenull(tempData)) {
				let {dutyEntries = []} = tempData
				//赋值
				for (let dutyEntry of dutyEntries) {
					let {dutyId, desc = ''} = dutyEntry
					desc = clearHtml(desc)
					if (desc.includes('<br/>')) {
						desc = desc.replace(/<br\/>/g, '\n')
					}
					this.planFormData[`item${dutyId}`] = desc
				}
			}
		},
		onSubmitPlan(form, done) {
			//操作成功
			// this.$message.success('确认 成功')
			// this.onCheckPlanResult(true)
			// done()
			this.doneData = done
			let tempData = this.deepClone(this.planFormData)
			this.onClearOtherData(tempData)
			//发送数据
			this.$emit('onSubmittedData', {type: 3, ...tempData})
		},
		// 识别成功后处理 true,确认， false 取消
		onCheckPlanResult(result) {
			if (this.planOption.submitBtn === !result) {
				return
			}
			this.planOption.submitBtn = !result
			this.planOption.column.forEach((item, index) => {
				if (item.type === 'select') {
					item.disabled = result
				}
			})
			this.onDealDone()
		},
		//去除loading
		onDealDone() {
			if (this.doneData) {
				this.doneData()
				this.doneData = null
			}
		},
		//plan 数据
		onGetSubPlanData() {
			let tempPlanData = this.deepClone(this.planFormData)
			//判断是否所有数据都好了
			if (!isAllDataReady(tempPlanData)) {
				return {}
			}
			//删除空数据
			this.onClearOtherData(tempPlanData)
			let {level = '', amount = ''} = tempPlanData
			tempPlanData.coverage = amount
			//特殊处理国寿财feeRate
			if (level !== '') {
				tempPlanData.feeRate = level
			}
			console.log('tempPlanData-----', tempPlanData)
			return tempPlanData
		},
		onClearOtherData(tempPlanData) {
			//删除空数据
			for (let tempPlanDataKey in tempPlanData) {
				if (tempPlanDataKey.includes('$') || tempPlanDataKey.includes('item')) {
					delete tempPlanData[tempPlanDataKey]
				}
			}
		},
		onSetPlanData(planData = {}) {
			//判断是否为mock数据
			let {isMock = false, coverage = ''} = planData
			this.isShowHint = false
			if (!isMock) {
				Object.assign(this.planFormData, planData)
				if (coverage) {
					this.planFormData.amount = `${coverage}`
				}
			} else {
				// mock数据
				this.planOption.column.forEach((itemData) => {
					let {prop, dicData = []} = itemData
					if (dicData.length > 0) {
						this.planFormData[prop] = dicData[0].value
					}
				})
			}
			setTimeout(() => {
				this.isShowHint = true
				this.onCheckPlanResult(false)
			}, 500)
		},
		onClearAreaDim() {
			this.$delete(this.planFormData, 'areaDim')
		},
		//是否确定
		isConfirm() {
			return this.planOption.submitBtn
		},
		//处理是不是有提示
		onHasHint(newVal, prop) {
			//如果是批增则不需要提示了
			if (this.isAdd) {
				return
			}
			//获取提示信息
			let {options = []} = this.planFormAllData[prop] || {}
			if (options.length > 0) {
				let tempData = options.find(({value}) => value === newVal) || {}
				let {hintInfo = {}} = tempData
				if (!this.validatenull(hintInfo)) {
					this.$refs.refInsureNotices.onShowNotices(hintInfo)
				}
			}
		},
		//提示确定
		onGoInsure() {},
		//提示取消
		//cancelAction === 2 是选择装卸责任触发
		onToCancel(params = {}) {
			let {cancelAction = -1, cancelParams = {}} = params
			if (cancelAction === 2) {
				Object.assign(this.planFormData, cancelParams)
			}
		},
		//通过计算保费，处理家电第三者
		onThirdChange(thirdType) {
			// this.thirdType = thirdType
			// //提示！！
			// this.onJiandianThird(false)
		},
		// 家电三者提示
		onJiandianThird(isMustHint = true) {
			if (this.isAdd) {
				//批增不显示
				return
			}
			let isContinue = true
			let hint = ''
			//家电 //0--没有购买过,1--买过不含三者,2--买过含三者
			let {thirdDuty = ''} = this.planFormData
			if (this.thirdType === '0') {
				hint =
					thirdDuty === '1'
						? '您已选择投保附加三者责任险，则后期购买该方案时都必须选择购买三者责任险，如已清楚了解，请点击确认。'
						: '您未选择投保附加三者责任险，则后期购买该方案时均无法再购买三者责任险，如已清楚了解，请点击确认。'
			} else if (this.thirdType === '1' && thirdDuty === '1') {
				hint =
					'贵单位已有在保保单未选购三者责任险，新投保也不支持购买三者责任险。原因：同一单位，在保保单若未选购三者责任险，后续投保将默认无法选购。'
				isContinue = false
			} else if (this.thirdType === '2' && thirdDuty === '2') {
				hint =
					'贵单位已有在保保单选购三者责任险，新投保也必须购买三者责任险。原因：同一单位，在保保单若选购三者责任险，后续投保将默认选购。'
				isContinue = false
			}
			if (hint !== '' && (isMustHint || this.thirdType !== '0') && this.isShowHint) {
				this.$alert(hint, '提示', {confirmButtonText: '我已知晓'}).then(() => {})
			}
			if (!isContinue) {
				this.planFormData.thirdDuty = ''
				//如果确认了 则取消
				this.onCheckPlanResult(false)
			}
		},
		//动态处理数据显示和隐藏
		onChangeOption() {
			let {duties = []} = this.dutyInfoData
			this.planOption.column.forEach((itemData) => {
				let {prop = ''} = itemData
				let tempData = duties.find(({id, showConditions = []}) => prop.includes(id) && showConditions.length > 0)
				if (!this.validatenull(tempData)) {
					let {showConditions = []} = tempData
					let {matchField, value} = showConditions[0]
					//处理显示隐藏
					itemData.display = this.planFormData[matchField] === value
				}
			})
		},
		onUnitCheck(emitData = {}) {
			let {errorCode = ''} = emitData
			if (errorCode === '220') {
				//取消确认方案
				this.onCheckPlanResult(false)
			}
		},
		//根据方案内容，展示类型
		onShowContentType() {
			let {ensureAmounts = []} = this.dutyInfoData
			if (ensureAmounts.length > 0) {
				let {dutyEntries = []} = ensureAmounts[0]
				if (dutyEntries.length > 0) {
					this.planOption.column.forEach((itemData) => {
						let {prop = ''} = itemData
						let {desc = ''} = dutyEntries.find(({dutyId = ''}) => prop.includes('item') && prop.includes(dutyId)) || {}
						if (desc && desc.length > 40) {
							itemData.type = 'textarea'
						}
					})
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
	padding: 20px 20px 0 20px;
}
</style>
